export default "__VITE_ASSET__D7I2Ze4t__"